<app-modal #modalComponent>
  <form [formGroup]="smsCodeForm">
    <div class="flex flex-col w-full">
      <div class="w-full">
        <app-form-input name="code" label="Entrez le code reçu par SMS" type="text" placeholder="Code SMS" [black]="true" [formGroup]="smsCodeForm"></app-form-input>
      </div>
    </div>
    <div class="py-3 flex justify-end">
      <app-button text="Valider" [disabled]="smsCodeForm.invalid" (onClick)="send()"></app-button>
    </div>
  </form>
</app-modal>
